module.exports = {"id":"212194","name":"Julian Brandt","rating":"82","photo":"./data/images/photos/4/212194.png","club":{"name":"Bayer 04","logo":"./data/images/clubs/Bayer04.png"},"positions":["MG","MD","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JulianBrandt0.json
// module id = 2236
// module chunks = 0